import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const BoldTypography = styled( Typography )( {
    fontWeight: "bold",
    color: "text.secondary",
    whiteSpace: "nowrap",
} );
